// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"6041fcef","377":"fd9aabf1","453":"67e8e7d6","465":"95bf4e0e","610":"928908ad"}[chunkId] + ".chunk.js";
};